module.exports = __webpack_public_path__ + "static/media/transporter.12a842f6.svg";